var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3749 0.00151094C11.194 -0.0430092 10.3192 0.922943 9.93976 1.95005C6.81638 8.19861 3.6957 14.4431 0.574567 20.6876C-0.16582 22.2548 1.27 24.1881 2.97194 23.9853C6.10072 23.9817 9.24568 23.9839 12.3749 23.9853C15.5037 23.9839 18.6491 23.9817 21.7779 23.9853C23.4802 24.1881 24.9161 22.2548 24.1752 20.6876C21.0536 14.4436 17.9339 8.19906 14.81 1.95005C14.4311 0.922494 13.5558 -0.0434589 12.3749 0.00151094ZM12.3749 5.40464C13.0366 5.40464 13.5738 5.94158 13.5738 6.60398L12.9746 14.9985H11.7757L11.1764 6.60398C11.1764 5.94158 11.7132 5.40464 12.3749 5.40464ZM12.3749 16.1974C13.0366 16.1974 13.5738 16.7348 13.5738 17.3967C13.5738 18.0587 13.0366 18.5961 12.3749 18.5961C11.7132 18.5961 11.176 18.0587 11.176 17.3967C11.176 16.7348 11.7132 16.1974 12.3749 16.1974Z",
    fill: "#D73939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedAlert);
export default __webpack_public_path__ + "static/media/red_alert.ee52749707d694225ecf55e99d2d9665.svg";
export { ForwardRef as ReactComponent };